import React from "react"
import { Provider } from "urql"

import { urqlClient } from "../utils/utils"

const GraphQLProvider = ({ children }) => <Provider value={urqlClient}>{children}</Provider>

export default GraphQLProvider
